import { WorkerExperiencesSection } from './worker-experiences-section';
import { TrainingSection } from './training-section';
import { CertificationSection } from './certification-section';
import { LanguageSection } from './language-section';

export const WorkerExperiencesTab = () => {
  return (
    <div className="flex flex-col items-start gap-6">
      <WorkerExperiencesSection />
      <LanguageSection />
      <TrainingSection />
      <CertificationSection />
    </div>
  );
};
